export default {"src":"/_next/static/media/discordIcon.fb5be2c0.svg","height":16,"width":16};